import { createFileRoute } from '@tanstack/react-router';

import Members from '~/app/praetors/settings/Members';

export const Route = createFileRoute('/_app/settings/members')({
	beforeLoad: () => {
		return {
			getTitle: 'Members'
		};
	},
	component: Members
});
